import getHiddenFields from "./getHiddenFields";

export default function getProjectHiddenFields() {
  var fds = getHiddenFields();
  fds = fds.concat([
    "ExportTemplates",
    "Contacts",
    "ContractorContacts",
    "ClientContacts",
    "Issues",
    "Checklists",
    "ChecklistTemplates",
    "Comments",
    "Files",
    "Observations",
    "Equipment",
    "issues_log",
    "allowed_emails",
    "projectStore_ids",
  ]);
  return fds;
}
